/**
 * Shown when the authenticated user has no record in the system
 * or has no roles assigned — mirrors Blazor's AccessDenied.razor.
 */
import { useEffect } from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { trackPageView } from "@/lib/analytics";

const RECIPIENT_EMAIL = "duscheduling@DELOITTE.com";
const SUBJECT = "Mable Application Access Request";
const BODY =
  "Hello,\n\nI am requesting access to the Mable application.\n\nPlease grant me the necessary permissions to use the system.\n\nThank you,\n[Your Name]";

const outlookEmailLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(RECIPIENT_EMAIL)}&subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(BODY)}`;

export function AccessDeniedPage() {
  const currentUser = useCurrentUser();
  const userId = currentUser?.email ?? "Unknown";

  // Track page view on mount
  useEffect(() => {
    trackPageView("Access Denied", userId);
  }, [userId]);
  return (
    <div className="flex min-h-screen items-start justify-center overflow-hidden px-3 pt-12">
      <div className="flex items-center gap-0">
        {/* Warning triangle icon — matches Blazor bi-exclamation-triangle */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          fill="red"
          viewBox="0 0 16 16"
          aria-hidden="true"
          className="flex-shrink-0"
        >
          <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
          <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
        </svg>

        <p className="pl-5 text-2xl leading-snug">
          Oops! Looks like you don&apos;t have access. Please click{" "}
          <a
            href={outlookEmailLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            here
          </a>{" "}
          to request access.
        </p>
      </div>
    </div>
  );
}

